import { ApiEndpoints } from "@shared/api/api-endpoints";
import { bxApiClient } from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const getSummaryData = async (id: any): Promise<any> => {
  const remoteUtilityId = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bill-generation-run/summary`,
    (qs: QueryStringParameters) => {
      qs.push("bill_run_id", id);
      qs.push("remote_utility_id", remoteUtilityId);
    }
  );
  const response = await bxApiClient.get(url);

  return response.data?.result;
};

export const getDashboardData = async (startDate: string, endDate: string) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "bill-dashboard",
    (qs) => {
      qs.push("start_date", startDate);
      qs.push("end_date", endDate);
    }
  );

  const response = await bxApiClient.get(url);
  return response.data?.data;
};

export const getBillCycleList = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `run-list-dropdown`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    }
  );
  const response = await bxApiClient.get(url);

  const data = response.data?.result;
  return data.map((item: any) => ({
    id: item.id,
    name: item.name,
    scheduleId: item.billSchedule,
  }));
};
